import { Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Base64Pipe } from '@apps/portal/src/app/shared/pipes/base64-pipe.pipe';
import { SharedModule } from '@apps/portal/src/app/shared/shared.module';
import { HlmAvatarComponent } from '@spartan-ng/ui-avatar-helm';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  standalone: true,
  imports: [SharedModule, Base64Pipe, HlmAvatarComponent],
})
export class AvatarComponent {
  @Input() imageSrc: string | SafeUrl = '';
  @Input() variant: 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge';
}
